export const getMDRAlertButtonClass = (project, type) => {
  if (project !== "MDR") return "";

  switch (type) {
    case "resolve":
      return "mark-resolve-button";
    case "falsePositive":
      return "false-positive-button";
    case "unresolve":
      return "mark-unresolved-button";
    default:
      return "";
  }
};

export const getMDRClassNames = (project, baseClass) => {
  return project === "MDR" ? `${baseClass} MDR` : baseClass;
};